export const PERMISSION = {
  MODULE: {
    MEETING_MANAGEMENT: "MEETING_MANAGEMENT",
    INTERVENTION_LABEL_MANAGEMENT: "INTERVENTION_LABEL_MANAGEMENT",
    TERMINOLOGY_MANAGEMENT: "TERMINOLOGY_MANAGEMENT",
    HOME_PAGE: "HOME_PAGE",
    MEETING_TRANSCRIPTION_PAGE: "MEETING_TRANSCRIPTION_PAGE",
  },
  ACTION: {
    CREATE: "create",
    LISTING: "listing",
    UPDATE: "update",
    DELETE: "delete",
    ASSIGN_ROLE: "assign_role",
    REORDER: "reorder",
    EXPORT: "export",
    JOIN_MEETING: "join_meeting",
    ADD_SPEAKER_SECTION: "add_speaker_section",
    EDIT_SPEAKER_SECTION: "edit_speaker_section",
    DELETE_SPEAKER_SECTION: "delete_speaker_section",
    REGENERATE_AGENDA_SUMMARY: "regenrate_agenda_summary",
    CHATBOT: "chatbot",
    COPY_SUMMARY: "copy_summary",
    SYNC_TO_REPO: "sync_to_repo",
    SEARCH: "search",
    FILTER: "filter",
    VIEW_AGENDA_SUMMARY: "view_agenda_summary",
    DELETE_AGENDA_SUMMARY: "delete_agenda_summary",
    CREATE_AGENDA_SUMMARY: "create_agenda_summary",
    START_AGENDA: "start_agenda",
    DELETE_INTERVENTION_SUMMARY: "delete_intervention_summary",
    EDIT_INTERVENTION_SUMMARY: "edit_intervention_summary",
    VIEW_INTERVENTION_SUMMARY: "view_intervention_summary",
    CREATE_INTERVENTION_SUMMARY: "create_intervention_summary",
    MERGE_TRANSCRIPTION: "merge_transcription",
    VIEW_TRANSCRIPTION: "view_transcription",
    START_RECORDING: "start_recording",
    STOP_RECORDING: "stop_recording",
    JOIN_SERVER_MEETING: "join_server_meeting",
    END_SERVER_MEETING: "end_server_meeting",
    COPY_MEETING_ID: "copy_meeting_id",
    IMPROVE_MEETING_PERFORMANCE: "improve_meeting_performance",
  },
};
